export const SAVE_SAVED_SEARCH_FILTERS = 'SAVE_SAVED_SEARCH_FILTERS';
export const CLEAR_SAVED_FILTERS = 'CLEAR_SAVED_FILTERS';
export const SET_LAST_SELECTED_SEARCH_NAME = 'SET_LAST_SELECTED_SEARCH_NAME';
export const SET_LAST_SELECTED_REPOSITORY_NAME = 'SET_LAST_SELECTED_REPOSITORY_NAME';

export const saveSavedSearchFilters = (searchName, savedSearchData) => ({
  type: SAVE_SAVED_SEARCH_FILTERS,
  payload: {
    searchName,
    savedSearchData,
  },
});

export const clearSavedFilters = (searchName) => ({
  type: CLEAR_SAVED_FILTERS,
  payload: {
    searchName,
  },
});

export const setLastSelectedSearchName = ({ key, searchName }) => ({
  type: SET_LAST_SELECTED_SEARCH_NAME,
  payload: {
    key,
    searchName,
  },
});

export const setLastSelectedRepositoryName = (repositoryName) => ({
  type: SET_LAST_SELECTED_REPOSITORY_NAME,
  payload: {
    repositoryName,
  },
});
